import AuthService from "services/AuthService";
import Sentry from "util/sentry";

export default async function sendDeviceInfoService(payload) {
    try {
        // console.log('analytics: sendDeviceInfoService', payload)
        await AuthService.sendDeviceAnalytics(payload)
    } catch (error) {
        Sentry.captureException(error, { 
            message: 'Error en sendDeviceInfoService()',
            extra: { payload }
        })
    }
}
